export default __webpack_public_path__ + "static/media/enlist-control-logo-512px.8ca4c4b9.png";